import highlitersConfig from './highlitersConfig';
import AceService from './highliter/ace';

const HighliteFactory = {};

HighliteFactory.create = function (highlighter) {
    if (highlighter === highlitersConfig.HIGHLITER_ACE) {
        return AceService;
    }
};

export default HighliteFactory;
